﻿(function () {
    'use strict';

    var serviceId = 'repository.alertSetting';

    angular
        .module('app.services')
        .factory(serviceId, alertSetting);

        alertSetting.$inject = ['common', 'repository.abstract'];
   
    function alertSetting(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getPortalAlerts = getPortalAlerts;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        
    }
})();